import DashboardHeader from "@/components/DashboardHeader";
import Dropzone from "@/components/dropzone/DropZone";
import { Button, Input } from "@thdinc/hpf-shared";
import SelectSearchInput from "@/components/selectInput/SelectSearchInput";
import { COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import React, { useEffect, useState, FC } from "react";
import IngredientTable from "./IngredientTable";
import { API_ROUTES } from "@/services/environment";
import { GET, POST_MULTIPART } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import useLoading from "@/hooks/useLoading";
import Alert from "@/components/alert/Alert";
import { useNavigate } from "react-router";
import ImageUploadFunDropZone from "@/utils/ImageUploadDropZoneFun";
import { cocktailInterface } from "../interface";
import { IoCloseSharp } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import FormModal from "@/components/modals/FormModal";
import IngrediantsBTC from "@/pages/btc/Cocktails/IngrediantsBTC";
import ToggleInput from "@/components/toggle/Toggle";
interface product {
  name: string;
  value: string;
  type: string;
}

interface props {
  businessId: string;
  isEdit?: boolean;
  isNew?: boolean;
  next?: () => void;
  prev?: () => void;
  closeCocktailForm?: () => void;
}

const CreateCocktails: React.FC<props> = ({
  businessId,
  isNew,
  prev,
  closeCocktailForm,
}) => {
  const dispatch = useDispatch();

  const { refreshToken, roles } = useAppSelector((store) => store.user);
  const { businessProducts, rawCcktailList, createCocktail, getAllCocktaillist } = API_ROUTES;
  const [cocktailsLibrary, setCocktailsLibrary] = useState<cocktailInterface[]>(
    []
  );
  const [isFeatured, setIsFeatured] = useState<boolean>(false);
  const [isPopular, setIsPopular] = useState<boolean>(false);
  const [cocktailImg, setCocktailImg] = useState<string | null>(null);
  const [cocktailImgFile, setCocktailImgFile] = useState<File | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [searchQuery, setSearchQuery] = useState("");

  const [cocktailName, setCocktailName] = useState<string>("");
  const [selectedType, setSelectedType] = useState<string>(
    COCKTAILS_TYPES_DATA[0].value
  );
  const [productsList, setProductsList] = useState<product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<product[]>([]); // products
  const [error, setError] = useState<string>("");
  const [imageError, setImageError] = useState<string>("");
  const [cocktailList, setCocktailList] = useState([]);
  const [ingredientList, setIngredientList] = useState<any>([]);
  const [newIngredient, setNewIngredient] = useState<any>([]);
  const [isCustomCocktail, setIsCustomCocktail] = useState<boolean>(false);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const openModal = () => setIsModalOpen(true);

  const closeModal = () => setIsModalOpen(false);
  const setNewIngredientFn = (value: any) => {
    const filtered = value.filter(
      (items: any) => items.qty_oz > 0 && items.name.length > 0
    );
    setNewIngredient(filtered);
  };
  const addCustomCocktail = () => {
    if (newIngredient && newIngredient.length <= 1) {
      setIsCustomCocktail((prevState) => {
        const newState = !prevState;
        if (newState) {
          const filtered = productsList.filter((p) => p.type === selectedType);
          setFilteredProducts(filtered);
        }
        else {
          setFilteredProducts(productsList)

        }
        return newState;
      });

    } else {
      if (isCustomCocktail) {
        setIsCustomCocktail(false);
        // setFilteredProducts([...productsList,{ value: "other", name: "other" ,type:''}])
      } else {
        Alert({
          type: "error",
          message: "Only one ingredient allowed in custom cocktail",
        });
      }
    }
  };
  useEffect(() => {
    getProducts();
    const getCocktailList = async () => {
      // list of all coctails avaialble
      try {
        const result = await GET(`${rawCcktailList}/${businessId}`, refreshToken);
        setCocktailList(result.data);
      } catch (err) {
        console.log(err);
      }
    };
    getCocktailList();
  }, [isLoading]);

  /* istanbul ignore next */
  const otherImagesUpload = (file: any) => {
    try {
      const f = ImageUploadFunDropZone(file);
      if (f) {
        setCocktailImgFile(f);
        setCocktailImg(URL.createObjectURL(f));
        setImageError("");
      }
    } catch (err: any) {
      console.log(err);
      setImageError(err.message);
    }
  };

  const getProducts = async () => {
    try {
      const result = await GET(`${businessProducts}/${businessId}`, refreshToken);
      const prodcuts = Array.isArray(result?.data)
        ? result.data.map((product: any) => ({
          name: product.name,
          value: product.id,
          type: product.type
        }))
        : [];

      setProductsList(prodcuts);

      setFilteredProducts(prodcuts);
    } catch (err) {
      console.log(String(err));
    }
  };
  interface ingredients {
    name?: string;
    qty_oz?: string;
    product_id?: string | null;
    product_type?: string;
    spirit_type?: string;
  }
  /* istanbul ignore next */
  const saveCocktail = async (list: ingredients[]) => {
    dispatch(formStateChange(false));

    if (!cocktailImg) {
      setImageError("Provide cocktail image");
      return;
    }
    setImageError("");
    if (cocktailName == "") {
      setError("Provide cocktail name");
      return;
    }
    startLoading();

    const formData = new FormData();
    formData.append("business_id", businessId);
    formData.append("type", selectedType);
    formData.append("featured", isFeatured.toString());
    formData.append("popular", isPopular.toString());
    formData.append("name", cocktailName);
    formData.append("is_custom_cocktail", isCustomCocktail?.toString());
    // the list of selected ingredients
    list.map((item, index) => {
      formData.append(`ingredients[${index}][name]`, item.name ?? "");
      formData.append(`ingredients[${index}][qty_oz]`, item.qty_oz ?? "");
      formData.append(`ingredients[${index}][product_id]`, item.product_id ?? "null");
      formData.append(`ingredients[${index}][spirit_type]`, item.spirit_type ?? "null");
    });
    // if file image  is uploaded
    if (cocktailImgFile) {
      formData.append("image", cocktailImgFile);
    } else if (cocktailImg) {
      formData.append("image", cocktailImg);
    }
    //  formData.append("ingredients", list);

    try {
      // create cocktail
      const result = await POST_MULTIPART(
        createCocktail,
        formData,
        refreshToken
      );
      if (result.data.success) {
        setCocktailName("");
        setIsFeatured(false);
        setCocktailImg(null);
        setCocktailImgFile(null);
        setIsPopular(false);
        setProductsList([]);
        setIngredientList([]);
        Alert({ message: result.data.message });
        if (isNew && closeCocktailForm) {
          console.log("should go edit");
          // to navigate back
          closeCocktailForm();
        } else if (isNew && cocktailList.length >= 2) {
          navigate("/company");
        }
      } else {
        Alert({ type: "error", message: result.data.message });
      }
    } catch (err) {
      console.log(String(err));
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      (async () => {
        try {
          const result = await GET(`${getAllCocktaillist}`, refreshToken);
          setCocktailsLibrary(result.data);
        } catch (error) {
          console.log(error);
        }
      })();
    }
  }, [isModalOpen]);

  /* istanbul ignore next */
  const addCocktailFromLib = (cocktail: cocktailInterface) => {
    setIngredientList([])
    setTimeout(() => {
      dispatch(formStateChange(true));
      setCocktailName(cocktail.name);
      setSelectedType(cocktail.type);
      setIsCustomCocktail(cocktail.is_custom_cocktail)
      setIsFeatured(cocktail.featured ? cocktail.featured : false);
      setIsPopular(cocktail.popular ? cocktail.popular : false);
      setIngredientList(cocktail.ingredients);
      // setCoctailImg(cocktail.image)
      setCocktailImg(cocktail.image);
      setIsModalOpen(false);
    }, 500)
  };

  // const searchedCocktails = (val:string)=>{
  //   console.log('val',val)
  //   const filteredCocktails = cocktailsLibrary.filter((cocktail) => cocktail.name.includes(val))
  //   setCocktailsLibrary(filteredCocktails)
  // }
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  /* istanbul ignore next */
  // search on cocktail name and btc
  const filteredCocktails = cocktailsLibrary.filter((item) => {
    const cocktailName = item.name.toLowerCase();
    const btc = item?.business_name?.toLowerCase();
    const search = searchQuery.toLowerCase();
    return cocktailName.includes(search) || btc?.includes(search);
  });
  return (
    <div className="mx-auto">
      <DashboardHeader title="New Cocktail">
        <Button classes="text-xs text-white rounded px-2 py-3 bg-primary-red cursor-pointer min-w-[140px]" onClick={openModal}>Cocktails Library</Button>
      </DashboardHeader>
      <FormModal
        modalTitle="Cocktails List"
        width="lg:w-5/12 md:w-5/6 w-full"
        overflow="overflow-hidden "
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <div className="flex justify-between">
          <h2 className="text-xl font-bold ">Cocktails List</h2>
          {/* <IoCloseSharp
            data-testid="close-icon"
            className="cursor-pointer"
            onClick={closeModal}
          /> */}
        </div>
        <div className="my-2 ">
          <Input
            placeholder="Search cocktail or btc"
            value={searchQuery}
            onChange={handleSearch}
          />
        </div>
        {filteredCocktails.length > 0 ? (
          <div className="overflow-y-auto">

            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
              <thead className="text-xs text-gray-700  bg-gray-50  ">
                <tr>
                  <th scope="col" className=" text-primary-red py-3">
                    Sr#.
                  </th>

                  <th scope="col" className=" text-primary-red py-3">
                    Cocktail
                  </th>
                  <th scope="col" className=" text-primary-red py-3">
                    BTC
                  </th>
                  <th scope="col" className=" text-primary-red py-3 ">
                    Type
                  </th>
                  <th scope="col" className=" text-primary-red py-3">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredCocktails.map((item: cocktailInterface, index) => {
                  return (
                    <tr
                      key={index}
                      className="odd:bg-white  even:bg-gray-50  border-b"
                    >
                      <th
                        scope="row"
                        className=" py-4 font-medium text-gray-900 whitespace-nowrap"
                      >
                        {index + 1}
                      </th>

                      <td className=" py-4 min-w-36">
                        <div className="flex items-center gap-2  ">
                          <img
                            className="rounded-lg w-12 h-12"
                            src={item.image}
                            width={50}
                            height={50}
                            alt="cocktail"
                          />
                          <p className="font-semibold">{item?.name}</p>
                        </div>
                      </td>
                      <td className=" py-4 min-w-36">
                        {" "}
                        <p>{item?.business_name}</p>{" "}
                      </td>
                      <td className=" py-4">{item?.type}</td>
                      <td className=" py-4">
                        <Button
                          classes="text-xs text-white rounded px-3 py-2 bg-primary-red cursor-pointer "
                          onClick={() => addCocktailFromLib(item)}
                        >
                          Add
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="loader-primary"></div>
        )}
      </FormModal>
      <div>
        <div className="flex flex-col xl:flex-row gap-5 min-h-[80vh]">
          {/* left sec */}
          <div className="xl:w-2/5 w-full flex flex-col gap-5 bg-white rounded-2xl p-6">
            <div className="flex flex-col mt-4   items-center">
              <Dropzone
                image={cocktailImg}
                removeImage={() => {
                  setCocktailImg(null);
                }}
                onDrop={otherImagesUpload}
              ></Dropzone>
              {imageError && (
                <p className="text-primary-red text-xs ">{imageError}</p>
              )}
              <div className=" font-semibold my-2">Cocktail Image</div>
            </div>
            <div className="flex gap-4 items-center flex-col sm:flex-row">
              <div className="w-full ">
                <div className=" font-semibold my-2">Cocktail Name *</div>
                <Input
                  className="w-full px-4 py-[9px] bg-p-gray rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
                  value={cocktailName}
                  maxLength={50}
                  onChange={(e) => {
                    dispatch(formStateChange(true));

                    setCocktailName(e.target.value), setError("");
                  }}
                  type="text"
                  placeholder="Cocktail Name"
                />
                {error && <p className="text-sm text-primary-red">{error}</p>}
              </div>
              <div className="w-full ">
                <div className=" font-semibold my-2">Base Spirit Type</div>
                <SelectSearchInput
                  placeholder="Select Type"
                  options={COCKTAILS_TYPES_DATA.filter(item => item.name !== 'Vermouth')}
                  value={selectedType}
                  onChange={(selectedValue: string) => {

                    if (isCustomCocktail) {
                      if (selectedValue === 'other') {
                        setIsCustomCocktail(false)
                      } else {
                        // const filtered = productsList.filter((p) => p.type === selectedValue);
                        setFilteredProducts(productsList);
                      }
                    }
                    setSelectedType(selectedValue);
                    dispatch(formStateChange(true));
                  }}
                />

                {/* <div className="flex gap-3 items-center text-sm text-primary-red mt-2 cursor-pointer">
                 <div
                   className="inline-block"
                   onClick={() => setAddTypeForm(!addtypeForm)}
                 >
                   <AddIcon />
                 </div>
                 <p>Add Secondary Alcohol</p>
               </div> */}
              </div>
            </div>
            <div className="w-full flex flex-wrap items-start justify-between mt-4 gap-2">
              <div className={`flex gap-2`}>
                <div
                  className={`flex  items-center gap-2  ${isFeatured && "bg-[#ffeee5]"
                    } px-3 py-2 rounded-full`}
                >
                  <p className=" font-semibold mr-2">Hottest Cocktail Mix</p>
                  <div className="flex items-end">
                    <Input
                      className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                      type="checkbox"
                      title="Featured"
                      checked={isFeatured}
                      onChange={(e) => {
                        dispatch(formStateChange(true));

                        setIsFeatured(e.target.checked);
                      }}
                    />
                  </div>
                </div>
                <div
                  className={`flex  items-center gap-2  ${isPopular && "bg-[#ffeee5] "
                    } px-3 py-2 rounded-full`}
                >
                  <p className=" font-semibold mr-2">Popular</p>
                  <Input
                    className="cursor-pointer appearance-none h-5 w-5 border border-gray-300 rounded-full checked:bg-primary-red checked:border-transparent focus:outline-none"
                    type="checkbox"
                    title="Popular"
                    checked={isPopular}
                    onChange={(e) => {
                      dispatch(formStateChange(true));

                      setIsPopular(e.target.checked);
                    }}
                  />
                </div>
              </div>
              {roles == 'admin' && selectedType !== 'other' && <div className="flex items-center gap-2 px-3 py-2 flex-wrap">
                <p className=" font-semibold mr-2">Custom Cocktail</p>
                <ToggleInput
                  onChange={() => addCustomCocktail()}
                  checked={isCustomCocktail}
                />
              </div>}
            </div>

            {/* optional form part */}
            {/* {addtypeForm && (
               <div className="w-full  ">
                 <div className=" font-semibold my-2">Alcohol Type </div>
                 <Input
                   onChange={(e) => {
                     setTypeInput(e.target.value);
                   }}
                   value={typeInput}
                   type="text"
                   placeholder="Alcohol Type"
                 />
                 <div className="text-end">
                   <Button classes="mt-2 " onClick={addNewAlcoholType}>
                     Save
                   </Button>
                 </div>
               </div>
             )} */}

            {/* <div className="w-full ">
               <div className=" font-semibold my-2">Brand</div>
               <SelectInput
                 disabled={false}
                 options={cocktailBrandsData}
                 value={"Cognac"}
                 onChange={(selectedValue: string) => {
                   console.log("de");
                 }}
               />
             </div> */}
          </div>
          {/* right */}
          <div className="xl:w-3/5 w-full flex flex-col gap-5 bg-white rounded-2xl p-6">
            {productsList.length > 0 && (
              <IngrediantsBTC
                isCustomCocktail={isCustomCocktail}
                loading={isLoading}
                saveCocktail={saveCocktail}
                productsList={filteredProducts}
                CurInggrediant={ingredientList}
                setNewIngredientFn={setNewIngredientFn}
                businessId={businessId}
                selectedType={selectedType}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
      onClick={handleOverlayClick}
    >
      <div className="bg-white p-6 rounded-lg lg:w-6/12 h-4/5 xl:w-5/12 md:w-11/12 overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default CreateCocktails;
